import { BotId, Dictionary } from '@feedyou/schema'
import { omit } from 'lodash'
import { alert } from '../../../lib/bootbox'

export const getReservedBotIdsForExistingIds = (existingIds: BotId[]) => {
  return existingIds.map(id => `${id}-test`)
}

export const alertHavingUnsavedChanges = () =>
  alert({
    title: '❌ Unsaved changes',
    message: 'You have unsaved changes, please save changes first!'
  })

export const alertHavingUnsavedChangesForTestEnvironment = (testName: string) =>
  alert({
    title: '❌ Unsaved changes',
    message: `${testName} environment has unsaved changes, please switch to ${testName} environment and save changes first!`
  })

export const removePrivilegedActions = (options: Dictionary<string, any>, testName: string) => {
  return {
    ...options,
    buttons: omit(options.buttons, ['ok']),
    message: `There is no active version in ${testName} environment.`
  }
}
